import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { FormGroup, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PickadateContext } from 'app/shared/models/timetables.model';
import * as moment from 'moment';
@Component({
    selector: 'gaweb-pick-a-time',
    template: `
    <input type="text"
       class="form-control"
       [id]="name"
       [name]="name"
       [placeholder]="placeholder"
       (valueChange)="valueChange($event)"
       [value]="value || ''"
       pickatime/>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PickATimeComponent),
            multi: true
        }
    ]
})
export class PickATimeComponent implements OnInit, ControlValueAccessor {
    @Input() form: FormGroup;
    @Input() placeholder: string;
    @Input() name: string;
    @Output() onValueChange: EventEmitter<any> = new EventEmitter();
    @Input() format = 'h:mm A';
    private _value: string;
    @Input() set value(v: string) {
        this._value = v;
    }
    get value() {
        return this._value;
    }

    onChange: any = () => { };
    onTouched: any = () => { };

    constructor() { }

    ngOnInit() {
    }
    valueChange(date: PickadateContext) {
        this.value = moment().set({
            'hour': Math.floor(date.select / 60),
            'minute': date.select % 60
        }).format(this.format);
        this.onValueChange.emit(date);
    }
    writeValue(value: any): void {
        if (value) {
            this.value = value;
        }
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pick-time/pick-a-time.component.ts